import { WorkingStepIconSvg } from 'components/Common/WorkingSteps/WorkingStepIcon'
import {
  forgetAsPurchasingPart,
  rememberAsPurchasingPart,
} from 'features/BillOfMaterials/store/asyncActions/rememberAsPurchasingPart'
import { bomItemIsPurchasingPartSelector } from 'features/BillOfMaterials/store/selectors/bomItemIsPurchasingPartSelector'
import { bomItemIsRememberedPurchasingBoMItemSelector } from 'features/BillOfMaterials/store/selectors/bomItemIsRememberedPurchasingBoMItemSelector'
import { bomItemMaterialSummarySelector } from 'features/BillOfMaterials/store/selectors/bomItemMaterialSummarySelector'
import { isEqual } from 'lodash'
import { useAppSelector } from 'store/configureStore'
import { WorkingStepType } from 'services/APIs/InternalAPI/internal-api.contracts'
import { BomItemMenuItem } from './BomItemMenuItem'

export const RememberOrForgetGeometryAsPurchasingMenuItem = ({
  bomItemId,
  onClose,
}: {
  bomItemId: string
  onClose: () => void
}) => {
  const isPurchasing = useAppSelector(
    bomItemIsPurchasingPartSelector(bomItemId)
  )
  const isRememberedPurchasingBoMItem = useAppSelector(
    bomItemIsRememberedPurchasingBoMItemSelector(bomItemId)
  )

  const materialSummary = useAppSelector(
    bomItemMaterialSummarySelector(bomItemId),
    isEqual
  )

  if (!isPurchasing) {
    return null
  }

  if (!isRememberedPurchasingBoMItem && materialSummary.id) {
    return (
      <BomItemMenuItem
        hiddenForBuyers
        action={rememberAsPurchasingPart}
        actionParams={{
          bomItemId,
          articleId: materialSummary.id,
        }}
        primaryTextTranslationKey="project:vertical-menu-remember-geometry-purchasing-item"
        secondaryTextTranslationKey="project:vertical-menu-remember-geometry-purchasing-item-desc"
        onClose={onClose}
        closeAfterFullfilled
        icon={
          <WorkingStepIconSvg
            workingStepType={WorkingStepType.Purchasing}
            attributes={{
              width: '2rem',
            }}
          />
        }
      />
    )
  }

  if (isRememberedPurchasingBoMItem) {
    return (
      <BomItemMenuItem
        action={forgetAsPurchasingPart}
        actionParams={{
          bomItemId,
        }}
        primaryTextTranslationKey="project:vertical-menu-forget-geometry-purchasing-item"
        secondaryTextTranslationKey="project:vertical-menu-forget-geometry-purchasing-item-desc"
        onClose={onClose}
        closeAfterFullfilled
        icon={
          <WorkingStepIconSvg
            workingStepType={WorkingStepType.Purchasing}
            attributes={{
              width: '2rem',
            }}
          />
        }
      />
    )
  }

  return null
}
